import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=68f888d6&scoped=true&"
import script from "./BaseSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=68f888d6&prod&lang=scss&"
import style1 from "./BaseSelect.vue?vue&type=style&index=1&id=68f888d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f888d6",
  null
  
)

export default component.exports